import clsx from "clsx";

function SectionItem(props) {
  const { sectionName, onSectionClick, isActive, icon } = props;
  return (
    <div
      onClick={onSectionClick}
      className={clsx(
        `w-full h-10 flex shrink-0 items-center rounded-lg justify-between px-4 hover:cursor-pointer ${
          isActive ? "bg-gray-100" : "hover:bg-gray-100 hover:outline outline-gray-200"
        }`
      )}
    >
      <div className="flex items-center gap-x-2">
        {icon && icon}
        <p className={`font-normal text-sm ${isActive && "font-semibold"}`}>
          {sectionName}
        </p>
      </div>
    </div>
  );
}

export { SectionItem };